import React, {useEffect, useState} from 'react';
import {Languages} from "../../utilities/Constants";
import Category from "../../classes/Category";
import Podcast from "../../classes/Podcast";
import PageTitle from "../../components/common/page-title/PageTitle";
import {Link} from "react-router-dom";
import PrimaryButton from "../../components/common/buttons/PrimaryButton";
import {FiPlus} from "react-icons/fi";
import FilterHeader from "../../components/common/header/FilterHeader";
import {Col, Container, Row} from "react-grid-system";
import SelectInput from "../../components/common/inputs/select-input/SelectInput";
import PaginationTableFooter from "../../components/common/footer/PaginationTableFooter";
import PodcastsTable from "../../components/tables/PodcastsTable";

const Podcasts = () => {

    const allCategory = {key: "-1", value: "All"};

    let limit = 15;

    const [podcasts, setPodcasts] = useState([]);
    const [podcastsCategories, setPodcastsCategories] = useState([allCategory]);
    const [loading, setLoading] = useState(true);

    const [selectedLanguage, setSelectedLanguage] = useState(Languages[0]);
    const [selectedCategory, setSelectedCategory] = useState(podcastsCategories[0]);

    const [currentPage, setCurrentPage] = useState(1);
    const [numberOfPages, setNumberOfPages] = useState(1);
    const [count, setCount] = useState(0);
    const [skip, setSkip] = useState(0);

    useEffect(() => {

        let isMounted = true;
        const controller = new AbortController();

        const fetchCategories = async () => {
            try {
                const results = await Category.getPickableQuery().find();
                if (isMounted) {
                    const mappedResults = [allCategory];
                    mappedResults.push(...results.map(function(item) { return {
                        key: item.id,
                        value: item.getTitle()
                    }}));
                    setPodcastsCategories(mappedResults);
                }
            }
            catch (error) {
                console.error(error);
            }
        }

        fetchCategories();

        return () => {
            isMounted = false;
            controller.abort();
        }

    }, []);

    useEffect(() => {

        let isMounted = true;
        const controller = new AbortController();

        const fetchPodcast = async () => {
            try {
                setLoading(true);
                const response = await Podcast.getFilteredQuery(
                    selectedLanguage.key,
                    selectedCategory.key === "-1" ? null : selectedCategory.key,
                    skip,
                    limit
                ).find();
                if (isMounted) {
                    setCount(response.count)
                    setNumberOfPages(Math.ceil(response.count / limit))
                    if (response.count === 0) {
                        setCurrentPage(0)
                    }
                    else {
                        setCurrentPage((skip + limit) / limit)
                    }
                    setPodcasts(response.results);
                }
            }
            catch (error) {
                console.error(error);
            }
            finally {
                if (isMounted) {
                    setLoading(false);
                }
            }
        }

        fetchPodcast();

        return () => {
            isMounted = false;
            controller.abort();
        }

    }, [selectedLanguage, selectedCategory, skip]);

    const languageSelectChangeHandler = (e) => {
        setSelectedLanguage(e);
        setSkip(0);
    }

    const podcastCategorySelectChangeHandler = (e) => {
        setSelectedCategory(e);
        setSkip(0);
    }

    return (
        <div className="Content-bottom-margin">
            <PageTitle title="Podcasts" brief={
                (selectedCategory ? selectedCategory.value : "All") + " • " + selectedLanguage.value
            }>
                <Link to="./new">
                    <PrimaryButton title="New podcast" icon={<FiPlus/>}/>
                </Link>
            </PageTitle>
            <FilterHeader>
                <Container fluid>
                    <Row gutterWidth={20} >
                        <Col sm={12} md={7}>
                            { <SelectInput name="podcast-categories"
                                           options={podcastsCategories}
                                           preSelectedOption={selectedCategory}
                                           onChange={podcastCategorySelectChangeHandler}/>
                            }
                        </Col>
                        <Col sm={12} md={3}>
                            <SelectInput name="podcasts-language-code"
                                         options={Languages}
                                         preSelectedOption={selectedLanguage}
                                         onChange={languageSelectChangeHandler}/>
                        </Col>
                    </Row>
                </Container>
            </FilterHeader>
            <PodcastsTable items={podcasts} loading={loading} footer={
                <PaginationTableFooter loading={loading}
                                       currentPage={currentPage}
                                       numberOfPages={ numberOfPages }
                                       onPrevious={ () => { setSkip(skip - limit) } }
                                       onNext={ () => { setSkip(skip + limit) } } >
                </PaginationTableFooter>
            } />
        </div>
    );
};

export default Podcasts;